@if (allowedteams?.length > 1){
    <mat-form-field class="team-selector">
        <mat-select [formControl]="selectedTeamCtrl" panelClass="team-select" >
            <mat-select-trigger>
                {{ selectedTeamCtrl.value?.name }}
            </mat-select-trigger>
            @for (team of allowedteams; track team) {
            <mat-option [value]="team">{{ team.name }}</mat-option>
            }
        </mat-select>
    </mat-form-field>
}
@if (allowedteams?.length === 1){
    <h3 data-cy="team-as-org">{{selectedTeamCtrl.value?.name}}</h3>
}